var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sidebar-footer" }, [
      _c("img", {
        staticClass: "labs-logo",
        attrs: { src: "static/img/labs_logo.svg", alt: "labs-img" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }